module.exports = __webpack_public_path__ + "img/37560-094.deeafd47.jpg";